import { DocumentFiles } from "domain/entities/document-files";
import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface DocumentFilesState {
  selectedDocumentFile: DocumentFiles | null;
  setSelectedDocumentFile: (item: DocumentFiles | null) => void;
  resetSelectedDocumentFile: () => void;
}

export const useDocumentFilesSelectedStore =
  create<DocumentFilesState>()(
    devtools(
      (set) => ({
        selectedDocumentFile: null,

        setSelectedDocumentFile: (item) =>
          set({ selectedDocumentFile: item }),

        resetSelectedDocumentFile: () =>
          set({ selectedDocumentFile: null }),
      }),
      { name: "DocumentFilesSelected" }
    )
  );